import { Button, Group, Text } from "@mantine/core";
import { ConfirmAndExecutePanel, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { DatosServiciosAutorizacion } from "./DatosServiciosAutorizacion";

export const ACTAutorizarReporte: EntityClientAction = {
    name: 'ACTAutorizarReporte',
    label: 'Autorizar Reporte',
    title: <Text fw={700}>Autorizar Reporte</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const datosServicioAutorizacion = entity as DatosServiciosAutorizacion;

        const procParms = {
            c_datos_servicio_id: selectedKeys?.[0]?.['c_datos_servicio_id'] ?? ''
        };

        let errores = '';

        if (!procParms.c_datos_servicio_id) {
            errores = 'Los registros seleccionados son inválidos';
        }

        if (errores) {
            await modal.open({
                modalProps: {
                    title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">ERROR</Text></Group>,
                },
                focusOnClosed: element,
                content:
                    <>
                        <Text size="sm" mb="xs">
                            {errores}
                        </Text>
                        <Group mt="xs" position="right">
                            <Button onClick={async () => await modal.close()}>Cerrar</Button>
                        </Group>
                    </>
            });

        }
        else {
            const abort_controller = new AbortController();

            await modal.open({
                modalProps: {
                    title: <Text fw="700">Autorizar Reporte</Text>
                },
                focusOnClosed: element,
                content: <ConfirmAndExecutePanel
                    content={<Text size="sm" mb="xs">Va a autorizar el reporte. ¿Está seguro?</Text>}
                    operation="proc"
                    onCancel={async () => { await abort_controller.abort(); await modal.close(); }}
                    onOK={
                        async () => {
                            const result = await datosServicioAutorizacion.API.executeProcess(datosServicioAutorizacion.def.procs.dasa_AutorizarReporte, procParms, abort_controller.signal);
                            const success = result.Failed === false;
                            if (onClose) await onClose(success);
                            if (success) await modal.close();
                            return result;
                        }
                    }
                />

            });
        }

        return false;
    }
}